export default "__VITE_ASSET__CoHksajl__"